import almaty_region from '../../Regions/almaty_region.json';
import akmola_region from '../../Regions/akmola_region.json';
import aktobe_region from '../../Regions/aktobe_region.json';
import abay_region from '../../Regions/abay_region.json';
import atyrau_region from '../../Regions/atyrau_region.json';
import eastkz_region from '../../Regions/eastkz_region.json';
import karagandy_region from '../../Regions/karagandy_region.json';
import kostanay_region from '../../Regions/kostanay_region.json';
import kyzylorda_region from '../../Regions/kyzylorda_region.json';
import mangystau_region from '../../Regions/mangystau_region.json';
import northkz_region from '../../Regions/northkz_region.json';
import pavlodar_region from '../../Regions/pavlodar_region.json';
import turkestan_region from '../../Regions/turkestan_region.json';
import ulytau_region from '../../Regions/ulytau_region.json';
import westkz_region from '../../Regions/westkz_region.json';
import zhambyl_region from '../../Regions/zhambyl_region.json';
import zhetisu_region from '../../Regions/zhetisu_region.json';

export const cluster_regions = [
  {
    type: 'Feature',
    id: 9,
    properties: {
      color: '#aed8e5',
    },
    geometry: almaty_region,
  },
  {
    type: 'Feature',
    id: 7,
    properties: {
      color: '#cccccc',
    },
    geometry: akmola_region,
  },
  {
    type: 'Feature',
    id: 8,
    properties: {
      color: '#a5bccc',
    },
    geometry: aktobe_region,
  },
  {
    type: 'Feature',
    id: 6,
    properties: {
      color: '#e2e1de',
    },
    geometry: abay_region,
  },
  {
    type: 'Feature',
    id: 10,
    properties: {
      color: '#d6d5d1',
    },
    geometry: atyrau_region,
  },
  {
    type: 'Feature',
    id: 11,
    properties: {
      color: '#d1d1d1',
    },
    geometry: eastkz_region,
  },
  {
    type: 'Feature',
    id: 15,
    properties: {
      color: '#e1e0dd',
    },
    geometry: karagandy_region,
  },
  {
    type: 'Feature',
    id: 16,
    properties: {
      color: '#cccccc',
    },
    geometry: kostanay_region,
  },
  {
    type: 'Feature',
    id: 17,
    properties: {
      color: '#e2e2e2',
    },
    geometry: kyzylorda_region,
  },
  {
    type: 'Feature',
    id: 18,
    properties: {
      color: '#e2e1de',
    },
    geometry: mangystau_region,
  },
  {
    type: 'Feature',
    id: 20,
    properties: {
      color: '#e2e2e2',
    },
    geometry: northkz_region,
  },
  {
    type: 'Feature',
    id: 19,
    properties: {
      color: '#e1e0dd',
    },
    geometry: pavlodar_region,
  },
  {
    type: 'Feature',
    id: 21,
    properties: {
      color: '#8fb6d7',
    },
    geometry: turkestan_region,
  },
  {
    type: 'Feature',
    id: 22,
    properties: {
      color: '#e2e1de',
    },
    geometry: ulytau_region,
  },
  {
    type: 'Feature',
    id: 14,
    properties: {
      color: '#899daa',
    },
    geometry: westkz_region,
  },
  {
    type: 'Feature',
    id: 12,
    properties: {
      color: '#b8d2e4',
    },
    geometry: zhambyl_region,
  },
  {
    type: 'Feature',
    id: 13,
    properties: {
      color: '#b8d2e4',
    },
    geometry: zhetisu_region,
  },
];
